module.exports = __webpack_public_path__ + "static/media/grandad.20d84d8e.jpg";